<template>
<v-container fluid style="height: 100vh;">
    <v-app-bar absolute color="white" flat dark style="padding-top:4vh">

        <v-toolbar-title>
            <v-list-item-title class="title" @click="backtohome">
                <img src="../assets/LinkRoom.jpg" width="20%" style="padding-left:3vh">

            </v-list-item-title>
        </v-toolbar-title>

        <v-spacer></v-spacer>
        <v-flex md6>

            <v-btn @click="showmenu = 1" style=" border-radius:20px" v-if="showmenu == 1" class="primary white--text" outlined>แบบละเอียด</v-btn>
            <v-btn @click="showmenu = 1" v-if="showmenu != 1" style=" border-radius:20px" class="white primary--text" outlined>แบบละเอียด</v-btn>

            <v-btn @click="showmenu = 2" style=" border-radius:20px" v-if="showmenu == 2" class="primary white--text" outlined>แบบตาราง</v-btn>
            <v-btn @click="showmenu = 2" v-if="showmenu != 2" style=" border-radius:20px" class="white primary--text" outlined>แบบตาราง</v-btn>
            <!-- <v-tabs v-model="tab" fixed-tabs style=" border-radius:20px" background-color="primary" dark hide-slider>

                <v-tab @click="showmenu = 1">แบบละเอียด</v-tab>
                <v-tab @click="showmenu = 2">แบบตาราง</v-tab>
            </v-tabs> -->

        </v-flex>
    </v-app-bar>
    <v-row fill-height style="padding-top:15vh">
        <v-container fluid style="height: 85vh;padding-left:5vh;padding-right:5vh" v-if="showmenu === 1">
            <v-row wrap>
                <!-- {{data.monitor}} -->
                <v-col cols="4" v-for="item in data.monitor" :key="item[0]">
                    <v-card width="100%" style="border-radius:20px ; padding-top:20px" height="38vh">
                        <v-row justify="center">
                            <v-col style="padding-left:5vh" cols="7">
                                <p style="font-size:20px;">
                                    {{item.room_name}}
                                </p>
                                <!-- <v-btn @click="login">test</v-btn> -->
                            </v-col>
                            <!-- <v-col cols="2"></v-col> -->
                            <v-col style="padding-left:5vh" cols="5">
                                <p class="subtitle" style="padding-top:1vh;font-size:16px">
                                    {{item.time_use}}
                                </p>
                            </v-col>
                            <v-col cols="12">
                                <p class="text-center " style="margin-bottom: 0px; font-size:28px">
                                    {{item.topic_now}}
                                </p>
                                <p class="text-center">
                                    {{item.user_use}}
                                </p>
                            </v-col>

                            <v-col cols="12" style="padding-top:0vh">
                                <v-card height=5vh color="primary" style="border-bottom-radius:20px">
                                    <p class="text-center white--text title">
                                        {{item.next_topic}}
                                    </p>
                                </v-card>
                            </v-col>

                        </v-row>

                    </v-card>
                </v-col>

                <!-- <v-col cols="4">
                    <v-card width="100%" style="border-radius:20px">
                        <v-row wrap>
                            <v-col style="padding-left:5vh" cols="5">
                                <p class="title">
                                    linkroom1
                                </p>
                            </v-col>
                            <v-col cols="2"></v-col>
                            <v-col style="padding-left:5vh" cols="4">
                                <p class="subtitle" style="padding-top:1vh">
                                    9:00 - 11:00
                                </p>
                            </v-col>
                            <v-col cols="12">
                                <p class="text-center display-1" style="margin-bottom: 0px;">ประชุมทีม Dev</p>
                                <p class="text-center">
                                    Arruk Libnoi
                                </p>
                            </v-col>

                            <v-col cols="12" style="padding-top:0vh">
                                <v-card height=100% color="primary" style="border-bottom-radius:20px">
                                    <p class="text-center white--text title">
                                        next : ประชุมทีม sale
                                    </p>
                                </v-card>
                            </v-col>
                        </v-row>
                    </v-card>
                </v-col>

                <v-col cols="4">
                    <v-card width="100%" style="border-radius:20px">
                        <v-row wrap>
                            <v-col style="padding-left:5vh" cols="5">
                                <p class="title">
                                    linkroom1
                                </p>
                            </v-col>
                            <v-col cols="2"></v-col>
                            <v-col style="padding-left:5vh" cols="4">
                                <p class="subtitle" style="padding-top:1vh">
                                    9:00 - 11:00
                                </p>
                            </v-col>
                            <v-col cols="12">
                                <p class="text-center display-1" style="margin-bottom: 0px;">ประชุมทีม Dev</p>
                                <p class="text-center">
                                    Arruk Libnoi
                                </p>
                            </v-col>

                            <v-col cols="12" style="padding-top:0vh">
                                <v-card height=100% color="primary" style="border-bottom-radius:20px">
                                    <p class="text-center white--text title">
                                        next : ประชุมทีม sale
                                    </p>
                                </v-card>
                            </v-col>
                        </v-row>
                    </v-card>
                </v-col>

                <v-col cols="4">
                    <v-card width="100%" style="border-radius:20px;  padding-top:40px">
                        <v-row wrap>
                            <v-col style="padding-left:5vh" cols="5">
                                <p class="title">
                                    linkroom1
                                </p>
                            </v-col>
                            <v-col cols="2"></v-col>
                            <v-col style="padding-left:5vh" cols="4">
                                <p class="subtitle" style="padding-top:1vh">
                                    9:00 - 11:00
                                </p>
                            </v-col>
                            <v-col cols="12">
                                <p class="text-center display-1" style="margin-bottom: 0px;">ประชุมทีม Dev</p>
                                <p class="text-center">
                                    Arruk Libnoi
                                </p>
                            </v-col>

                            <v-col cols="12" style="padding-top:0vh">
                                <v-card height=100% color="primary" style="border-bottom-radius:20px">
                                    <p class="text-center white--text title">
                                        next : ประชุมทีม sale
                                    </p>
                                </v-card>
                            </v-col>
                        </v-row>
                    </v-card>
                </v-col>
                <v-col cols="4">
                    <v-card width="100%" style="border-radius:20px;  padding-top:40px">
                        <v-row wrap>
                            <v-col style="padding-left:5vh" cols="5">
                                <p class="title">
                                    linkroom1
                                </p>
                            </v-col>
                            <v-col cols="2"></v-col>
                            <v-col style="padding-left:5vh" cols="4">
                                <p class="subtitle" style="padding-top:1vh">
                                    9:00 - 11:00
                                </p>
                            </v-col>
                            <v-col cols="12">
                                <p class="text-center display-1" style="margin-bottom: 0px;">ประชุมทีม Dev</p>
                                <p class="text-center">
                                    Arruk Libnoi
                                </p>
                            </v-col>

                            <v-col cols="12" style="padding-top:0vh">
                                <v-card height=100% color="primary" style="border-bottom-radius:20px">
                                    <p class="text-center white--text title">
                                        next : ประชุมทีม sale
                                    </p>
                                </v-card>
                            </v-col>
                        </v-row>
                    </v-card>
                </v-col>
                <v-col cols="4">
                    <v-card width="100%" style="border-radius:20px;  padding-top:40px">
                        <v-row wrap>
                            <v-col style="padding-left:5vh" cols="5">
                                <p class="title">
                                    linkroom1
                                </p>
                            </v-col>
                            <v-col cols="2"></v-col>
                            <v-col style="padding-left:5vh" cols="4">
                                <p class="subtitle" style="padding-top:1vh">
                                    9:00 - 11:00
                                </p>
                            </v-col>
                            <v-col cols="12">
                                <p class="text-center display-1" style="margin-bottom: 0px;">ประชุมทีม Dev</p>
                                <p class="text-center">
                                    Arruk Libnoi
                                </p>
                            </v-col>

                            <v-col cols="12" style="padding-top:0vh">
                                <v-card height=100% color="primary" style="border-bottom-radius:20px">
                                    <p class="text-center white--text title">
                                        next : ประชุมทีม sale
                                    </p>
                                </v-card>
                            </v-col>
                        </v-row>
                    </v-card>
                </v-col> -->

            </v-row>
        </v-container>

        <v-container fluid style="height: 100vh;" v-if="showmenu === 2">

            <v-row fill-height style="padding-top:5vh">
                <v-container fluid style="height: 85vh;padding-left:5vh;padding-right:5vh">
                    <v-row wrap>

                        <v-col cols="12">
                            <!-- <v-card width="100%"  style="border-radius:20px"> -->
                            <v-data-table width="500" :headers="headers" :items="data.datatablemonitor" :items-per-page="5" class="elevation-1">

                            </v-data-table>
                            <!-- </v-card> -->
                        </v-col>
                    </v-row>
                </v-container>
            </v-row>
        </v-container>
    </v-row>

</v-container>
</template>

<script>
import {
    Data
} from '../models'
import {
    mapState,
    dispatch,
    mapActions,
    store
} from 'vuex'
export default {
    data() {
        return {
            tab: null,
            showmenu: 1,
            headers: [{
                    text: 'ชื่อผู้จอง',
                    align: 'start',
                    sortable: false,
                    value: 'user_name',
                },
                {
                    text: 'เรื่องที่จอง',
                    value: 'topic'
                },
                {
                    text: 'เวลา',
                    value: 'time_use'
                },
                {
                    text: 'ห้อง',
                    value: 'room_name'
                },

            ],
            desserts: [{
                    name: 'Somchai Jaidee',
                    title: 'ประชุม Sale',
                    time: '8.00 - 10.00',
                    room: 'Linkroom 1',
                },
                {
                    name: 'Arruk Libnoi',
                    title: 'ประชุม Sale',
                    time: '8.00 - 10.00',
                    room: 'Linkroom 1',
                },
                {
                    name: '',
                    title: '',
                    time: '',
                    room: 'Linkroom 1',
                },
                {
                    name: '',
                    title: '',
                    time: '',
                    room: 'Linkroom 1',
                },
                {
                    name: '',
                    title: '',
                    time: '',
                    room: 'Linkroom 1',
                },
            ]
        }
    },

    methods: {
        // ready() {
        //     window.setInterval(() => {
        //         console.log("kkkk")
        //     }, 1000);
        // },
        getmonitor(){
            // console.log(".....")
            this.$store.dispatch("datas/getmonitor")
        },
        backtohome(){
            console.log("go to home")

            clearInterval(this.interval)

            this.$router.push({
                    name: 'Home'

                });
        }
    },

    created() {
        // this.$store.dispatch("datas/getbooking")
        this.$store.dispatch("datas/getmonitor")

        this.interval = setInterval(() => this.getmonitor(), 15000);
    },
    computed: {
        ...mapState('datas', {
            data: 'data'
        }),
    },

}
</script>
